import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import { ErrorBoundary } from './ErrorBoundary';
import { PageWrapperDiv } from './Shared.styles';

export const PageWrapper = (): ReactElement => {
  return (
    <PageWrapperDiv>
      <ErrorBoundary>
        <Outlet />
      </ErrorBoundary>
    </PageWrapperDiv>
  );
};
